import { Link } from "@tanstack/react-router"

import { Button } from "@/components/ui/button"
import { Card, CardTitle } from "@/components/ui/card"
import ApplicationsImage from "@/svg/home/applications.svg?react"

export function HomeGuideCard() {
  return (
    <Card className="relative min-w-0 overflow-hidden p-6">
      <div className="relative z-10 flex h-full min-w-0 flex-col justify-between md:pr-[min(10rem,45%)]">
        <div>
          <div className="mb-6">
            <CardTitle>Partner Guide</CardTitle>
          </div>
          <p className="mb-4">
            Access all the resources you need to become the ultimate partner and
            confidently guide companies through their funding journey.
          </p>
        </div>

        <Button className="bg-primary self-start" asChild>
          <Link to="/partners/guide">View Applications</Link>
        </Button>
      </div>

      <ApplicationsImage className="pointer-events-none absolute right-0 hidden h-auto w-full md:bottom-0 md:block md:w-48 xl:w-48" />
    </Card>
  )
}
